import { render } from "./WildGameMoveModal.vue?vue&type=template&id=6228daee"
import script from "./WildGameMoveModal.vue?vue&type=script&lang=js"
export * from "./WildGameMoveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__